import { render } from "./ModulosPermisos.vue?vue&type=template&id=07cc7d11"
import script from "./ModulosPermisos.vue?vue&type=script&lang=js"
export * from "./ModulosPermisos.vue?vue&type=script&lang=js"

import "./ModulosPermisos.vue?vue&type=style&index=0&id=07cc7d11&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__